import { connect } from "react-redux";
import { browserHistory } from "react-router";
import appPath from "utils/appPath";
import userActions from "ducks/user";
import User from "services/User";
import marketingActions from "ducks/marketing";
import loginActions from "ducks/loginRegister";
import { setThinking, doneThinking } from "ducks/thinking";
import { SCREENS, SOCIAL_MEDIA, ELOQUA_LEAD_SOURCE_VALUES } from "common/constants/Constants";
import Message from "utils/Message";
import Redirect, { onRedirectWhitelist } from "utils/Redirect";
import { hasBulkSubsRedirectTo } from "utils/bulkSubscriptionUtils";
import { hasSubsRedirectTo } from "common/utils/subscriptionHelpers";

export function createMapStateToProps() {
    return (state, ownProps) => {
        const { loginRegister = {}, thinking } = state;
        const { location: { query } } = ownProps;

        const hasBulkSubsRedirect = hasBulkSubsRedirectTo(query);
        const hasSubsRedirect = hasSubsRedirectTo(query);

        return {
            thinking,
            bloombergSiteUrl: state.config.bloombergSiteUrl,
            grecaptchaApiKey: state.config.grecaptchaApiKey,
            email: loginRegister.email,
            password: loginRegister.password,
            errors: loginRegister.errors,
            forgotPasswordLink: appPath.withIframePrefix(SCREENS.FORGOT_PASSWORD),
            signupLink: appPath.withIframePrefix(SCREENS.REGISTER),
            showAlertModal: loginRegister.showAlertModal,
            hasBulkSubsRedirect,
            hasSubsRedirect
        };
    };
}

export function mapDispatchToProps(dispatch, ownProps) {
    return {
        checkUser() {
            if (User.hasUserToken()) {
                return User.fetchUser()
                    .then((user) => dispatch(loginActions.redirectAfterCheckUser(user)));
            }
        },

        socialLogin(socialSite) {
            dispatch(setThinking());

            return dispatch(loginActions.socialLogin(socialSite))
                .then((loginDetails) => {
                    if (loginDetails.newSocialLogin) {
                        dispatch(marketingActions.sendEmailToEloquaAndCpref(
                            loginDetails.socialEmail, ELOQUA_LEAD_SOURCE_VALUES.SOCIAL_LOGIN));
                    }

                    return loginDetails;
                })
                .then(() => dispatch(userActions.startFetchingUser()))
                .then(redirectIfTerminalUser(socialSite, ownProps.location))
                .then((user) => dispatch(loginActions.redirectAfterSignIn(user, ownProps.location)))
                .then(() => dispatch(doneThinking()))
                .catch((error) => {
                    dispatch(doneThinking());

                    if (error.status === 401) {
                        browserHistory.push(appPath.withIframePrefix(SCREENS.REGISTER));
                    }
                });
        },

        onEmailChange(newEmail) {
            return dispatch(loginActions.emailChange(newEmail));
        },

        onPasswordChange(newPassword) {
            return dispatch(loginActions.passwordChange(newPassword));
        },

        forgotPassword() {
            return browserHistory.push(appPath.withIframePrefix(SCREENS.FORGOT_PASSWORD));
        },

        login(email, password, captcha) {
            dispatch(loginActions.clearError("login"));
            dispatch(setThinking());

            return dispatch(loginActions.login(email, password, captcha))
                .then(() => dispatch(userActions.startFetchingUser()))
                .then((user) => dispatch(loginActions.redirectAfterSignIn(user, ownProps.location)))
                .then(() => dispatch(doneThinking()))
                .catch((error) => {
                    dispatch(doneThinking());

                    if (error.status === 401) {
                        browserHistory.push(appPath.withIframePrefix(SCREENS.REGISTER));
                    }
                });
        },

        closeModal() {
            dispatch(loginActions.hideAlertModal());
        }
    };
}

export function redirectIfTerminalUser(socialSite, location) {
    return (user) => {
        if (socialSite !== SOCIAL_MEDIA.TERMINAL) {
            return user;
        }

        if (appPath.isIframePath()) {
            Message.userSignedIn(user);
            Message.closeWindow();

            return;
        }

        const TERMINAL_REDIRECT_WHITELIST = [
            "/bulk-subscriptions"
        ];

        if (onRedirectWhitelist(TERMINAL_REDIRECT_WHITELIST, location.query.redirectTo)) {
            Redirect.redirectTo(location.query.redirectTo);
        } else {
            browserHistory.push(appPath(SCREENS.ACCOUNT));
        }

        return Promise.reject({}); // early-exits the promise chain
    };
}

function createRegistrationSignInContainer(component) {
    return connect(
        createMapStateToProps(),
        mapDispatchToProps
    )(component);
}

export default createRegistrationSignInContainer;
